import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, Type } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TRANSLATION_CREATION_DIALOG_COMPONENT } from '../../translation-creation-dialog.token';
import { ClientTranslationCreationData } from '../../models/language-locale.model';
import { TranslationKeyCreationRefData } from '../../models/translation-key-creation-ref-data';

import { TranslationManagerService } from '../translation-manager.service';

@Injectable({
	providedIn: 'root'
})
export class TranslationKeyCreationService {
	private _translationKeyCreationRefData: TranslationKeyCreationRefData = null;

	constructor(
		private dialog: MatDialog,
		private httpClient: HttpClient,
		@Inject('environment') public environment: any,
		private translationManagerService: TranslationManagerService,
		@Inject(TRANSLATION_CREATION_DIALOG_COMPONENT) private creationDialogComponent: Type<any>
	) {}

	public get translationKeyCreationRefData() {
		return this._translationKeyCreationRefData;
	}

	public openKeyCreationModal(): void {
		const dialogRef = this.dialog.open(this.creationDialogComponent, {
			height: '80vh',
			width: '80vw'
		});
	}

	public createTranslationKeyRecord(translationData: ClientTranslationCreationData): Promise<void> {
		return new Promise((resolve, reject) => {
			this.httpClient
				.post<any>(this.environment.apiUrl + 'api/Contract/CreateNewTranslationRecord', translationData)
				.toPromise()
				.then(
					(response) => {
						this.translationManagerService.translationDataModified.emit(null);
						resolve(response);
					},
					(error) => {
						console.log(new Error(error));
						reject(new HttpErrorResponse(error));
					}
				);
		});
	}

	public getTranslationKeyCreationRefData(): Observable<TranslationKeyCreationRefData> {
		let refDataObservable: Observable<TranslationKeyCreationRefData> = null;

		if (this.translationKeyCreationRefData == null) {
			refDataObservable = this.httpClient
				.get<TranslationKeyCreationRefData>(
					this.environment.apiUrl + `api/Contract/GetTranslationKeyCreationRefData`
				)
				.pipe(
					tap((refData: TranslationKeyCreationRefData) => {
						this._translationKeyCreationRefData = refData;
						return refData;
					})
				);
		} else {
			refDataObservable = of(this.translationKeyCreationRefData);
		}
		return refDataObservable;
	}
}
